<script>
  import PageTitle from '$lib/teach/resources/PageTitle.svelte';
  const fontDefinitionImageAlt =
    'Key for uTheory Solfege Hand Signs font. Use the first letter of the solfege, lower case, for a hand sign view from the perspective of the person making the hand sign. Use the first letter of the solfege, upper case, for a view from the perspective of someone looking at a hand sign.';
  const fontDefinitionImageUrl = '/teach/solfege-font/solfege-key-map-quick-view.png';
  const url = '/teach/resources/kodaly-curwen-solfege-hand-signs-font';
  const licenseUrl = 'http://creativecommons.org/licenses/by-nc-nd/4.0/';
</script>

<PageTitle
  title="Kodaly/Curwen Solfege Hand Signs Font & Images"
  description="Free downloadable images and font of the Kodaly/Curwen/Glover solfege hand signs, created by the authors of uTheory.com."
  seoImageUrl={fontDefinitionImageUrl}
  seoImageAlt={fontDefinitionImageAlt}
  seoUrl={url}
  largeImage
/>
<div>
  <img
    class="mt-4 mb-8 mx-auto sm:mx-6 sm:w-5/12 sm:float-left self-start"
    src={fontDefinitionImageUrl}
    alt={fontDefinitionImageAlt}
  />
  <div class="text-gray">
    <h2 class="my-3">
      Downloadable font and images for the Kodály/Curwen solfege hand-signs, which are used
      throughout the world by Kodály and Orff teachers.
    </h2>
    <p class="my-3">
      Use them to create your own worksheets, sight singing materials, flash cards, posters -- the
      only limit is your creativity!
    </p>
    <p class="my-3">
      Includes diatonic and chromatic hand signs from both a first-person (self) perspective, and a
      third-person (teacher) perspective.
    </p>
    <p class="my-3">
      These are provided free for non-commercial use by uTheory, and are licensed under the
      <a class="a" rel="license" href={licenseUrl} target="_blank">cc-by-nc-nd</a> license.
    </p>
    <p class="my-3" />
    <ul class=" list-disc ml-8">
      <li>
        <a
          href="/teach/solfege-font/utheory-solfege-font-0.1.6.zip"
          rel="external"
          download
          class="a">Download Font Package (zip)</a
        >
        <p>Includes:</p>
        <ul class="list-disc ml-8">
          <li>TTF, WOFF, WOFF2 and SVG fonts</li>
          <li>PNG and SVG images of all hand signs</li>
          <li>Keyboard map</li>
        </ul>
      </li>
      <li>
        <a href="/teach/solfege-font/utheory-solfege-key-map.pdf" rel="external" class="a"
          >Download Font Key Map (pdf)</a
        >
      </li>
      <li>
        <a href={licenseUrl} class="a">License</a>
      </li>
    </ul>
    <p class="my-4">If you like the font, you might enjoy these related resources:</p>
    <ul class=" list-disc ml-8">
      <li>
        uTheory's <a class="a" rel="external" href="https://utheory.com/meme"
          >Solfege Meme Generator</a
        >
      </li>
      <li>
        <a
          class="a"
          rel="external"
          href="https://info.utheory.com/8-ways-to-use-utheorys-meme-generator-with-your-students/"
          >Eight Ways to Use uTheory's Solfege Meme Generator</a
        > in your classroom
      </li>
      <li>uTheory's <a class="a" href="/app/lessons">Ear Training Lessons</a></li>
      <li>uTheory's <a class="a" href="/app/skills">Ear Training Practice</a></li>
      <li>
        <a class="a" href="/teach/resources">Printable Music Theory Resources</a> from uTheory
      </li>
    </ul>
  </div>
</div>
